var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
export var useWakeLock = function () {
    var _a = useState(null), wakeLock = _a[0], setWakeLock = _a[1];
    var _b = useState(false), isWakeLockSupported = _b[0], setIsWakeLockSupported = _b[1];
    var _c = useState(false), isMobile = _c[0], setIsMobile = _c[1];
    /**
     * Check if device is mobile or tablet and Wake Lock API is supported
     */
    useEffect(function () {
        // Check if device is mobile or tablet
        var checkMobileOrTablet = function () {
            var userAgent = navigator.userAgent.toLowerCase();
            // Check for desktop user agents first
            var isDesktop = /windows|macintosh|linux/i.test(userAgent) && !/mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
            // Mobile devices (including responsive mobile)
            var isMobile = /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent) || !isDesktop && window.innerWidth <= 768;
            // Tablets (iPad, Android tablets)
            var isTablet = /ipad|android(?=.*\b(?!.*mobile).*)/i.test(userAgent) || !isDesktop && window.innerWidth <= 1024 && window.innerWidth > 768 && window.innerHeight <= 1366 && window.innerHeight > 800;
            setIsMobile(isMobile || isTablet);
        };
        checkMobileOrTablet();
        // Check if Wake Lock API is supported
        var supported = 'wakeLock' in navigator;
        setIsWakeLockSupported(supported);
    }, []);
    /**
     * Request to keep the screen awake using Screen Wake Lock API
     * This is the closest alternative to overriding lock screen settings
     * Note: Must be called in response to user interaction due to browser security policies
     */
    var requestWakeLock = function () { return __awaiter(void 0, void 0, void 0, function () {
        var wakeLock_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    if (!(isWakeLockSupported && isMobile)) return [3 /*break*/, 2];
                    return [4 /*yield*/, navigator.wakeLock.request('screen')];
                case 1:
                    wakeLock_1 = _a.sent();
                    setWakeLock(wakeLock_1);
                    // Add event listener to detect when wake lock is released
                    wakeLock_1.addEventListener('release', function () {
                        setWakeLock(null);
                    });
                    return [2 /*return*/, wakeLock_1];
                case 2: return [2 /*return*/, null];
                case 3: return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Release the wake lock
     * This should be called when you no longer need to keep the screen awake
     */
    var releaseWakeLock = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!wakeLock) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, wakeLock.release()];
                case 2:
                    _a.sent();
                    setWakeLock(null);
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Enable wake lock on first user interaction
     * This is required because browsers only allow wake lock requests after user interaction
     */
    useEffect(function () {
        var enableWakeLockOnInteraction = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!wakeLock && isWakeLockSupported && isMobile)) return [3 /*break*/, 2];
                        return [4 /*yield*/, requestWakeLock()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        // Listen for the first user interaction (click, touch, keypress, etc.)
        var handleFirstInteraction = function () {
            enableWakeLockOnInteraction();
            // Remove the event listeners after first interaction
            document.removeEventListener('click', handleFirstInteraction);
            document.removeEventListener('touchstart', handleFirstInteraction);
            document.removeEventListener('keydown', handleFirstInteraction);
        };
        // Only add event listeners if wake lock is supported and on mobile
        if (isWakeLockSupported && isMobile) {
            document.addEventListener('click', handleFirstInteraction);
            document.addEventListener('touchstart', handleFirstInteraction);
            document.addEventListener('keydown', handleFirstInteraction);
        }
        return function () {
            document.removeEventListener('click', handleFirstInteraction);
            document.removeEventListener('touchstart', handleFirstInteraction);
            document.removeEventListener('keydown', handleFirstInteraction);
        };
    }, [wakeLock, isWakeLockSupported, isMobile]);
    /**
     * Handle visibility change to re-acquire wake lock when app becomes visible
     * This is necessary because wake lock is automatically released when PWA loses focus
     */
    useEffect(function () {
        var handleVisibilityChange = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(document.visibilityState === 'visible' && !wakeLock && isWakeLockSupported && isMobile)) return [3 /*break*/, 2];
                        return [4 /*yield*/, requestWakeLock()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        if (isWakeLockSupported && isMobile) {
            document.addEventListener('visibilitychange', handleVisibilityChange);
        }
        return function () {
            if (isWakeLockSupported && isMobile) {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            }
        };
    }, [wakeLock, isWakeLockSupported, isMobile]);
    /**
     * Cleanup wake lock when component unmounts
     */
    useEffect(function () {
        return function () {
            // Release wake lock when app is closed/unmounted
            if (wakeLock) {
                releaseWakeLock();
            }
        };
    }, []);
    return {
        wakeLock: wakeLock,
        requestWakeLock: requestWakeLock,
        releaseWakeLock: releaseWakeLock,
        isWakeLockSupported: isWakeLockSupported,
        isWakeLockActive: wakeLock !== null,
        isMobile: isMobile
    };
};
export default useWakeLock;
